import Vue from 'vue'

export default {
  setCollapsed(state, collapsed) {
    state.collapsed = collapsed
  },
  setContext(state, context) {
    state.context = context
  },
  setPages(state, pages) {
    state.pages = pages
  },
  setThemes(state, themes) {
    state.themes = themes
  },
  selectCategory(state, category) {
    state.selectedCategory = category
  },
  removeTheme(state, id) {
    state.themes = state.themes.filter(theme => theme.id !== id)
  },
  setTheme(state, updatedTheme) {
    const currentIndex = state.themes.findIndex(theme => theme.id === updatedTheme.id)
    Vue.set(state.themes, currentIndex, updatedTheme)
  },
}
